// WHAT: Thin-Wrapper um `ScoreCard` für den Oura-Readiness-Score
// WHY:  Stellt eine klar benannte, wiederverwendbare Readiness-Komponente im Oura-Dashboard bereit
// DOMAIN: health → oura → molecules
// DEPENDENCIES: `ScoreCard`-Molecule
import { type FC } from "react";

import { ScoreCard } from "./ScoreCard";

interface ReadinessScoreProperties {
  score: number;
  trend?: "down" | "stable" | "up";
  trendValue?: number;
}

export const ReadinessScore: FC<ReadinessScoreProperties> = ({ score, trend, trendValue }) => {
  return (
    <ScoreCard
      description="How ready you are"
      maxScore={100}
      score={score}
      title="Readiness Score"
      {...(trend !== undefined && { trend })}
      {...(trendValue !== undefined && { trendValue })}
    />
  );
};
